<template>
  <NuxtLink :to="`${newsletterCard.link}`" target="_blank">
    <div class="newsletter-card">
      <div class="newsletter-card__author">
        <SanityImage
          :asset-id="assetId"
          :width="35"
          auto="format"
          class="newsletter-card__userpic"
          fit="clip"
          h="70"
        />
        <div class="newsletter-card__name">
          <p v-if="authorName">{{ authorName }}</p>
          <p v-if="authorMeta.speciality" class="newsletter-card__speciality">
            {{ authorMeta.speciality }}
          </p>
        </div>
      </div>

      <div class="newsletter-card__title">
        <h3>{{ newsletterCard.title }}</h3>
      </div>

      <div class="newsletter-card__footer">
        <div class="newsletter-card__day">
          {{ newsletterCard.day }} день войны
        </div>
      </div>
    </div>
  </NuxtLink>
</template>

<script setup>
import { computed } from '#imports';

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
});

const assetId = computed(() => props.item.letterAuthor.author.image.asset._ref);
const authorMeta = computed(() => props.item.letterAuthor);
const authorName = computed(() => props.item.letterAuthor.author.name);
const newsletterCard = computed(() => props.item);
</script>

<style lang="postcss" scoped>
.newsletter-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  height: 100%;
  min-height: 304px;
  padding: 16px 24px;
  transition: var(--default-transition) background-color;
  border: 1px solid rgba(17, 17, 17, 10%);
  border-radius: 16px;
  background-color: rgba(var(--white-color--rgb), 0.7);

  &:hover {
    background-color: rgba(var(--white-color--rgb), 1);
  }

  @media (--small-vp) {
    min-height: 210px;
  }

  &__userpic {
    width: 35px;
    height: 35px;
    border-radius: 50%;
  }

  &__title {
    flex-grow: 1;
    margin-top: 20px;

    @media (--small-vp) {
      line-height: 24px;
    }
  }

  &__name {
    font-size: 14px;
  }

  &__speciality {
    font-size: 10px;
    line-height: 16px;
  }

  &__author {
    display: flex;
    align-content: center;
    align-items: center;
    flex-direction: row;
    gap: 8px;
  }

  &__footer {
    &::after {
      display: block;
      width: 100%;
      height: 1px;
      margin-top: 4px;
      content: '';
      border-top: 1px solid rgba(17, 17, 17, 10%);
    }
  }

  &__day {
    font-size: 14px;
    line-height: 24px;
  }
}
</style>
